'use client'

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts'
import type { MonthlyDataPoint } from '../types'

const chartConfig = {
  total: {
    label: 'Total de Conversas',
    color: 'hsl(var(--primary))',
  },
} satisfies ChartConfig

interface ConversationsOverviewProps {
  data: MonthlyDataPoint[]
}

export function ConversationsOverview({ data }: ConversationsOverviewProps) {
  const chartData = data.map((item) => ({
    name: item.month,
    total: item.total,
  }))
  return (
    <ChartContainer config={chartConfig}>
      <BarChart
        data={chartData}
        margin={{
          top: 20,
          right: 20,
          left: 10,
          bottom: 10,
        }}
      >
        <CartesianGrid strokeDasharray='3 3' vertical={false} />
        <XAxis
          dataKey='name'
          stroke='#888888'
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke='#888888'
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(value) => `${value}`}
        />
        <ChartTooltip
          cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
          content={
            <ChartTooltipContent
              formatter={(value) => [`${value} conversas`]}
            />
          }
        />
        <Bar
          dataKey='total'
          fill='var(--color-total)'
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ChartContainer>
  )
} 